// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"264f2b34","842":"4365bae3"}[chunkId] + ".chunk.js";
};